import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${siteUrl}/#organization`,
  name: 'tek RVA',
  url: siteUrl,
  logo: {
    '@type': 'ImageObject',
    url: 'https://static.readdy.ai/image/bbcc86dc4c3a385b7f9b9f3a7e24f053/bc58823c9490a9cd55c8713379f1f7d6.jfif',
    width: 64,
    height: 64,
  },
  description:
    'tek RVA provides professional managed IT services, cybersecurity, cloud solutions, and 24/7 technical support specifically for Virginia nonprofits.',
  telephone: '+1-804-613-6131',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Richmond',
    addressRegion: 'VA',
    addressCountry: 'US',
  },
  areaServed: {
    '@type': 'State',
    name: 'Virginia',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+1-804-613-6131',
    contactType: 'customer service',
    availableLanguage: 'English',
    contactOption: 'TollFree',
    areaServed: 'US',
  },
  sameAs: [],
};

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${siteUrl}/#localbusiness`,
  name: 'tek RVA',
  url: siteUrl,
  description:
    'Voted Best Virginia MSP for Nonprofit Organizations. Professional IT services, cybersecurity, and cloud solutions for Virginia nonprofits.',
  telephone: '+1-804-613-6131',
  image:
    'https://static.readdy.ai/image/bbcc86dc4c3a385b7f9b9f3a7e24f053/bc58823c9490a9cd55c8713379f1f7d6.jfif',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Richmond',
    addressRegion: 'VA',
    addressCountry: 'US',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:30',
      closes: '17:30',
    },
  ],
  priceRange: '$$',
  serviceArea: {
    '@type': 'State',
    name: 'Virginia',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'IT Services for Nonprofits',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Managed IT Services' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Cybersecurity Solutions' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Cloud Solutions' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '24/7 Help Desk Support' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Network Infrastructure' } },
    ],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${siteUrl}/#website`,
  url: siteUrl,
  name: 'tek RVA',
  description:
    'Professional IT services and support for Virginia nonprofits — managed IT, cybersecurity, cloud solutions, and 24/7 technical support.',
  publisher: { '@id': `${siteUrl}/#organization` },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${siteUrl}/#webpage`,
  url: siteUrl,
  name: 'tek RVA - Professional IT Services & Support for Virginia Nonprofits',
  isPartOf: { '@id': `${siteUrl}/#website` },
  about: { '@id': `${siteUrl}/#organization` },
  description:
    'tek RVA provides professional managed IT services, cybersecurity, cloud solutions, and 24/7 technical support specifically for Virginia nonprofits.',
  dateModified: '2026-03-26',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: siteUrl,
      },
    ],
  },
};

const schemas = [organizationSchema, localBusinessSchema, websiteSchema, webPageSchema];

export default function SEOJsonLd() {
  useEffect(() => {
    const inserted: HTMLScriptElement[] = [];

    schemas.forEach((schema, index) => {
      const id = `schema-ld-${index}`;
      let el = document.getElementById(id) as HTMLScriptElement | null;
      if (!el) {
        el = document.createElement('script');
        el.id = id;
        el.type = 'application/ld+json';
        document.head.appendChild(el);
        inserted.push(el);
      }
      el.textContent = JSON.stringify(schema);
    });

    return () => {
      inserted.forEach((el) => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    };
  }, []);

  return null;
}
